import React from "react"
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  pdf,
  Image
} from "@react-pdf/renderer"
import logo from "../images/logo.png"
import firmaSupervisor from "../images/firma david.jpeg"

const PdfOrdenServicio = ({ data }) => {
  let folio = data?.idOrdenServicio
  let fechaInicio = data?.fechaSolicitud
  let fechaFinal = data?.eliminado
  let vehiculo = data?.checklists?.datoschecklists?.carros?.economico
  let vin = data?.checklists?.datoschecklists?.carros?.vin
  let kilometraje = data?.checklists?.gasolinachecklists?.kilometraje
  let operador = data.creados?.nombreCompleto
  let refacciones = data?.refacciones || []
  let observaciones = data?.observaciones || []
  let tipoChecklist = data?.checklists?.datoschecklists?.tipoChecklist
  let inspecciones = data?.inspecciones || []
  let marca = data?.checklists?.datoschecklists?.carros?.marca || ""
  let modelo = data?.checklists?.datoschecklists?.carros?.modelo || ""
  let tipoServicio = data?.checklists?.datoschecklists?.tipoServicio
  let manosObra = data?.manosObraOrdenServicio || []

  const refaccionesAgrupadas = Object.values(
    refacciones.reduce((acc, ref) => {
      const idProducto = ref.productos.idProducto
      const precioUnitario = Number(ref.productos?.precioPublico || 0)

      if (!acc[idProducto]) {
        acc[idProducto] = {
          ...ref,
          cantidad: ref.cantidad,
          precioUnitario,
          subtotal: precioUnitario * ref.cantidad
        }
      } else {
        acc[idProducto].cantidad += ref.cantidad
        acc[idProducto].subtotal += precioUnitario * ref.cantidad
      }

      return acc
    }, {})
  )

  const totalRefacciones = refaccionesAgrupadas.reduce(
    (sum, r) => sum + r.subtotal,
    0
  )

  const totalManoObra = manosObra.reduce(
    (sum, item) => sum + Number(item.precio || 0),
    0
  )

  const total = totalRefacciones + totalManoObra

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <Image source={logo} style={{ width: "30%" }} />
          <Text style={styles.title}>ORDEN DE TRABAJO</Text>
          <Text style={styles.ordenDeTrabajo}>No. {folio}</Text>
        </View>

        <View style={styles.infoSection}>
          <View
            style={[
              styles.infoRow,
              { flexDirection: "row", flexWrap: "wrap", alignItems: "center" }
            ]}
          >
            <Text style={styles.infoLabel}>
              VEHÍCULO: {vin + " / " + vehiculo}
            </Text>
            <Text style={styles.infoLabel}>ODÓMETRO: {kilometraje} km</Text>
            <Text style={styles.infoLabel}>FECHA INICIO: {fechaInicio}</Text>
          </View>
        </View>

        <View style={styles.infoSection}>
          <View
            style={[
              styles.infoRow,
              { flexDirection: "row", flexWrap: "wrap", alignItems: "center" }
            ]}
          >
            <Text style={styles.infoLabel}>TIPO REVISION: {tipoChecklist}</Text>
            <Text style={styles.infoLabel}>
              MARCA/MODELO: {marca + " / " + modelo}
            </Text>
            <Text style={styles.infoLabel}>FECHA TERMINO: {fechaFinal}</Text>
          </View>
        </View>

        <View style={styles.infoRow}>
          <Text style={styles.infoLabel2}>SERVICIO: {tipoServicio}</Text>
        </View>

        <View
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
            marginBottom: "10px"
          }}
        >
          {/* <View style={styles.subtitle}>
            <Text>FAVOR DE LLENAR CADA UNO DE LOS DATOS INDICADOS</Text>
          </View> */}
        </View>

        {/* Checkbox section */}
        {/* <View style={styles.checkboxSection}>
          <Text style={styles.subtitle}>
            TIPO DE MANTENIMIENTO (EN CASO DE SER MÁS DE UNO, INDICAR TIEMPO)
          </Text>
          <View style={styles.checkboxContainer}>
            {tiposUnicos.map((tipo, index) => (
              <View style={styles.checkboxRow} key={index}>
                <Text style={styles.checkboxLabel}>{tipo}</Text>
                <Image
                  source={
                    tiposSeleccionados.includes(tipo.trim().toLowerCase())
                      ? checkedCheckbox
                      : uncheckedCheckbox
                  }
                  style={{ width: 12, height: 12, marginLeft: 5 }}
                />
              </View>
            ))}
          </View>
        </View> */}

        <View
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
            marginBottom: "10px"
          }}
        >
          <View style={styles.subtitle}>
            <Text>INSPECCIONES/DIAGNOSTICOS</Text>
          </View>
        </View>

        <View style={styles.partsSection}>
          <View style={styles.partsTable}>
            {inspecciones.map((item, i) => {
              return (
                <View
                  key={i}
                  style={{
                    display: "flex",
                    width: "100%",
                    borderBottom: "1px solid black",
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black"
                  }}
                >
                  <Text
                    style={{
                      paddingLeft: "10px",
                      fontSize: "12px",
                      color: "black"
                    }}
                  >
                    {i + 1}-. {item.inspeccion}
                  </Text>
                </View>
              )
            })}
          </View>
        </View>

        <View
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
            marginBottom: "10px"
          }}
        >
          <View style={styles.subtitle}>
            <Text>CORRECCION DE FALLA</Text>
          </View>
        </View>

        <View style={styles.partsSection}>
          <View style={styles.partsTable}>
            {observaciones.map((item, i) => {
              return (
                <View
                  key={i}
                  style={{
                    display: "flex",
                    width: "100%",
                    borderBottom: "1px solid black",
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black"
                  }}
                >
                  <Text
                    style={{
                      paddingLeft: "10px",
                      fontSize: "12px",
                      color: "black"
                    }}
                  >
                    {i + 1}-. {item.observacion}
                  </Text>
                </View>
              )
            })}
          </View>
        </View>

        {/* Parts Section */}
        <View style={styles.partsSection}>
          <View
            style={{
              display: "flex",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              backgroundColor: "yellow",
              border: "1px",
              fontSize: 14
            }}
          >
            <Text>REFACCIONES UTILIZADAS</Text>
          </View>
          <View style={styles.partsTable}>
            <View style={styles.partsRow}>
              <Text style={styles.partsCellNumber}>No.</Text>
              <Text style={styles.partsCellName}>No. Parte</Text>
              <Text style={styles.partsCellName}>Refacción</Text>
              <Text style={styles.partsCellQty}>Cant.</Text>
              <Text style={styles.partsCellPrice}>Precio</Text>
              <Text style={styles.partsCellPrice}>Subtotal</Text>
            </View>
          </View>
          <View style={styles.partsTable}>
            {refaccionesAgrupadas.length > 0 ? (
              refaccionesAgrupadas.map((ref, i) => (
                <View style={styles.partsRow} key={i}>
                  <Text style={styles.partsCellNumber}>{i + 1}</Text>

                  <Text style={styles.partsCellName}>
                    {ref.productos?.numParte}
                  </Text>

                  <Text style={styles.partsCellName}>
                    {ref.productos?.nombreProducto}
                  </Text>

                  <Text style={styles.partsCellQty}>{ref.cantidad}</Text>

                  <Text style={styles.partsCellPrice}>
                    ${ref.precioUnitario.toFixed(2)}
                  </Text>

                  <Text style={styles.partsCellPrice}>
                    ${ref.subtotal.toFixed(2)}
                  </Text>
                </View>
              ))
            ) : (
              <Text>No hay refacciones disponibles</Text>
            )}
          </View>
        </View>

        <View style={styles.totalRow}>
          <Text style={styles.totalLabel}>TOTAL REFACCIONES</Text>
          <Text style={styles.totalValue}>${totalRefacciones.toFixed(2)}</Text>
        </View>

        {/* Mano de Obra / Servicios Section */}
        <View style={styles.partsSection}>
          <View
            style={{
              display: "flex",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              backgroundColor: "yellow",
              border: "1px",
              fontSize: 14
            }}
          >
            <Text>MANO DE OBRA / SERVICIOS</Text>
          </View>

          {/* Header */}
          <View style={styles.partsTable}>
            <View style={styles.partsRow}>
              <Text style={styles.partsCellNumber}>No.</Text>
              <Text style={styles.partsCellCode}>Código</Text>
              <Text style={styles.partsCellDescription}>
                Servicio / Descripción
              </Text>
              <Text style={styles.partsCellPrice}>Precio</Text>
            </View>
          </View>

          {/* Body */}
          <View style={styles.partsTable}>
            {manosObra.length > 0 ? (
              manosObra.map((item, i) => (
                <View style={styles.partsRow} key={i}>
                  {/* No. */}
                  <Text style={styles.partsCellNumber}>{i + 1}</Text>

                  {/* Código */}
                  <Text style={styles.partsCellCode}>
                    {item?.manosObra?.codigo || "-"}
                  </Text>

                  {/* Servicio / Descripción */}
                  <Text style={styles.partsCellDescription}>
                    {item?.manosObra?.descripcion || "-"}
                  </Text>

                  {/* Precio */}
                  <Text style={styles.partsCellPrice}>
                    ${Number(item?.precio || 0).toFixed(2)}
                  </Text>
                </View>
              ))
            ) : (
              <Text style={{ padding: 5 }}>No hay servicios registrados</Text>
            )}
          </View>
        </View>

        <View style={styles.totalRow}>
          <Text style={styles.totalLabel}>TOTAL: </Text>
          <Text style={styles.totalValue}>${total.toFixed(2)}</Text>
        </View>

        {/* Signatures Section */}
        <View style={styles.signaturesSection}>
          <View style={styles.signatureBlock}>
            <View style={styles.signatureLine} />
            <Text style={styles.signatureLabel}>FIRMA OPERADOR</Text>
          </View>
          <View style={styles.signatureBlock}>
            <Image
              source={firmaSupervisor}
              style={{
                width: 120,
                height: 60,
                objectFit: "contain",
                marginBottom: 4
              }}
            />
            <View style={styles.signatureLine} />
            <Text style={styles.signatureLabel}>FIRMA SUPERVISOR</Text>
          </View>
          <View style={styles.signatureBlock}>
            <Text style={styles.signatureName}>{operador}</Text>
            <View style={styles.signatureLine} />
            <Text style={styles.signatureLabel}>FIRMA TÉCNICO</Text>
          </View>
        </View>
      </Page>
    </Document>
  )
}

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: "20px"
  },
  title: {
    fontSize: 16,
    fontWeight: "bold",
    color: "red",
    marginLeft: "-60px"
  },
  ordenDeTrabajo: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 4
  },
  infoSection: {
    marginBottom: 20,
    flexDirection: "row",
    justifyContent: "space-between",
    flexWrap: "wrap"
  },
  infoRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
    width: "100%"
  },
  infoLabel: {
    width: "24%",
    fontWeight: "bold",
    textAlign: "center"
  },
  infoLabelFull: {
    width: "100%",
    fontWeight: "bold",
    textAlign: "center"
  },
  checkboxSection: {
    marginBottom: 20
  },
  checkboxRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 5
  },
  checkboxLabel: {
    marginLeft: 5
  },
  section: {
    marginBottom: 20
  },
  subtitle: {
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 10
  },
  partsSection: {
    marginBottom: 20
  },
  partsTableHeader: {
    backgroundColor: "yellow",
    padding: 5,
    textAlign: "center",
    fontWeight: "bold"
  },
  partsTable: {
    borderWidth: 1,
    borderColor: "#000"
  },
  partsRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#000"
  },
  partsCellNumber: {
    width: "10%",
    padding: 5,
    borderRightWidth: 1,
    borderColor: "#000",
    textAlign: "center"
  },
  partsCellName: {
    width: "65%",
    padding: 5,
    borderRightWidth: 1,
    borderColor: "#000",
    textAlign: "left"
  },
  partsCellQuantity: {
    width: "25%",
    padding: 5,
    textAlign: "center"
  },
  signaturesSection: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end", // 👈 alinear todos por la base
    marginTop: 20
  },
  signatureLine: {
    borderTopWidth: 1,
    borderColor: "#000",
    paddingTop: 5,
    textAlign: "center"
  },

  // Agrega este nuevo estilo para el nombre (ajusta el tamaño si es necesario)
  signatureName: {
    fontSize: 10, // Mismo tamaño que la etiqueta o un poco más grande
    textAlign: "center",
    marginBottom: 5, // Espacio antes de la línea
    fontWeight: "bold"
  },

  // Modifica signatureBlock para eliminar la línea de borde superior y que quede solo en signatureLine
  signatureBlock: {
    width: "33%",
    alignItems: "center",
    justifyContent: "flex-end",
    minHeight: 120 // 👈 asegura que todos midan lo mismo
  },
  signatureLabel: {
    fontSize: 10,
    fontWeight: "bold"
  },
  checkboxContainer: {
    flexDirection: "row",
    flexWrap: "wrap", // Para que los checkboxes se envuelvan a la siguiente línea
    justifyContent: "space-between",
    marginRight: 5
  },
  partsCellCode: {
    width: "20%",
    padding: 5,
    borderRightWidth: 1,
    borderColor: "#000",
    textAlign: "center"
  },
  partsCellDescription: {
    width: "50%",
    padding: 5,
    borderRightWidth: 1,
    borderColor: "#000",
    textAlign: "left"
  },
  partsCellPrice: {
    width: "20%",
    padding: 5,
    textAlign: "right"
  },
  partsCellQty: {
    width: "10%",
    padding: 5,
    borderRightWidth: 1,
    borderColor: "#000",
    textAlign: "center"
  },
  totalRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: 5,
    paddingRight: 10
  },
  totalLabel: {
    fontSize: 12,
    fontWeight: "bold",
    marginRight: 10
  },
  totalValue: {
    fontSize: 12,
    fontWeight: "bold"
  }
})

const blobToExport = async (data) => {
  return await pdf(<PdfOrdenServicio data={data} />).toBlob()
}

export default blobToExport
